<template lang="html">
  <d-row>
    <!-- Editor -->
    <d-col lg="10" class="mb-4">
      <d-card class="card-small">

        <!-- Form Example -->
        <d-card-header class="border-bottom">
          <h6 class="m-0">Lista de perguntas</h6>
        </d-card-header>

        <d-list-group flush>
          <d-list-group-item class="p-0">
            <d-form @submit.prevent="save">
              <draggable
                v-model="model.questions"
                group="people"
                ghost-class="ghost"
                @start="drag=true"
                @end="drag=false"
              >
                <d-form-row v-for="(row, index) in model.questions" :key="index" class="drag-row align-items-center">
                  <d-col class="form-group" cols="10">
                    <div class="col-delete">
                      <d-badge theme="success">{{index + 1}}</d-badge>
                      <i class="material-icons delete" @click="deleteRow(index)">delete</i>
                    </div>
                    <label for="name">Pergunta</label>
                    <d-form-input
                      type="text"
                      id="name"
                      placeholder="Nome"
                      v-model="row.question"
                    />
                  </d-col>
                  <d-col class="form-group col-type" cols="2">
                    <label for="User">Tipo</label>
                    <d-select
                      v-model="row.type"
                      :options="options"
                      require
                    ></d-select>
                  </d-col>
                </d-form-row>
                <d-form-row v-if="model.questions.length === 0" class="drag-row align-items-center">
                  <d-col class="no-content">Ainda não tem nenhuma pergunta criada.</d-col>
                </d-form-row>
              </draggable>

              <d-form-row class="p-3">
                <d-col cols="12">
                  <d-button size="sm" type="button" class="btn-accent ml-auto" @click="addQuestion">
                    <i class="material-icons">add</i> Adicionar outra
                  </d-button>
                </d-col>
              </d-form-row>
            </d-form>
          </d-list-group-item>
        </d-list-group>
      </d-card>
    </d-col>

    <!-- Sidebar Widgets -->
    <d-col lg="2" md="12">
      <sidebar-actions  />
    </d-col>
  </d-row>
</template>

<script>
import draggable from 'vuedraggable';
import { mapActions } from 'vuex';
import { cloneDeep } from '_utils';
import Events from '_utils/events';
import RatingService from '_services/rest/modules/rating';
import SidebarActions from './SidebarActions.vue';
import { MODEL_RATING, _SAVE_MODEL_, _LOAD_MODEL_, MODEL_QUESTION_TYPE, MODEL_QUESTION } from './RatingModel';

export default {
  name: 'questions',
  components: {
    draggable,
    SidebarActions,
  },
  props: {},
  data() {
    return {
      model: cloneDeep(MODEL_RATING),
      options: MODEL_QUESTION_TYPE,
    };
  },
  computed: {},
  watch: {},
  methods: {
    ...mapActions([
      'activeAlert',
    ]),
    addQuestion() {
      this.model.questions.push({ ...MODEL_QUESTION });
    },
    deleteRow(index) {
      this.model.questions.splice(index, 1);
      if (this.model.questions.length === 0) {
        this.addQuestion();
      }
    },
    reorder() {
      return this.model.questions.map((question, index) => {
        question.order = index;
        question.rating_id = this.model.id;
        return question;
      });
    },
    save() {
      const questions = this.reorder();
      RatingService.saveQuestions(this.model.id, questions)
        .then(() => {
          this.activeAlert({ message: 'Questões atualizada com sucesso!', theme: 'success' });
        }).catch(error => this.activeAlert({ message: `${error.message} <br/> ${error.data}`, theme: 'danger' }));
    },
  },
  mounted() {
    Events.$on(_LOAD_MODEL_, questions => {
      this.model = cloneDeep(questions);
    });
    Events.$on(_SAVE_MODEL_, () => {
      this.save();
    });
  },
};
</script>

<style lang="scss" scoped>
@import '~_scss/overrides';

.drag-row {
  padding: 30px 15px 30px 50px;
  margin: 0;
  cursor: move;
  border-bottom: 1px solid $border-color;
  position: relative;
  margin-bottom: 0;
  .form-group {
    margin-bottom: 0;
  }
  .badge {
    position: relative;
    padding: 0.373rem .6rem;
    font-size: 20px;
    top: -10px;
  }
  .col-10 {
    position: relative;
  }
  .col-delete {
    position: absolute;
    width: 30px;
    vertical-align: middle;
    left: -37px;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    .delete {
      font-size: 1.7rem;
      cursor: pointer;
      position: relative;
      vertical-align: middle;
    }
  }
}

.ghost {
  opacity: 0.5;
  background: #c8ebfb;
}
</style>
